/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { UpdateTranscriptionWordsFragmentDetailMutationRequest, UpdateTranscriptionWordsFragmentDetailMutationResponse, UpdateTranscriptionWordsFragmentDetailPathParams, UpdateTranscriptionWordsFragmentDetail404 } from "../models/UpdateTranscriptionWordsFragmentDetail";

export function getUpdateTranscriptionWordsFragmentDetailUrl(id: UpdateTranscriptionWordsFragmentDetailPathParams["id"]) {
  const res = { method: 'PUT', url: `/fragments/${id}/transcription/words` as const }
  return res
}

/**
 * @summary Replace fragment transcription words
 * {@link /fragments/:id/transcription/words}
 */
export async function updateTranscriptionWordsFragmentDetail(id: UpdateTranscriptionWordsFragmentDetailPathParams["id"], data: UpdateTranscriptionWordsFragmentDetailMutationRequest, config: Partial<RequestConfig<UpdateTranscriptionWordsFragmentDetailMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<UpdateTranscriptionWordsFragmentDetailMutationResponse, ResponseErrorConfig<UpdateTranscriptionWordsFragmentDetail404>, UpdateTranscriptionWordsFragmentDetailMutationRequest>({ method : "PUT", url : getUpdateTranscriptionWordsFragmentDetailUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}